import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-mfa-telephone-modal',
  templateUrl: './mfa-telephone-modal.component.html',
  styleUrls: ['./mfa-telephone-modal.component.css'],
})
export class MfaTelephoneModalComponent implements OnInit {

  @ViewChild('mfaTelephoneModal', { static: false }) mfaTelephoneModal: ModalDirective;

  readonly SCREEN_ID = 'O83';

  public phoneNumber: string;

  public observer: Observer<boolean>;

  public observable: Observable<boolean>;

  public smartInTelephoneNumber: string;

  public normalDisplay: string;
  public isFromThisDevice: boolean;
  public page1: string;
  public page2: string;
  public bottonDisabled: boolean;


  constructor(private sanitizer: DomSanitizer) {
    this.observable = new Observable(observer => { this.observer = observer; });
    this.smartInTelephoneNumber = environment.smartInTelephoneNumber;
    this.isFromThisDevice = true;
    this.page1 = '';
    this.page2 = 'none';
    this.bottonDisabled = false;
  }

  ngOnInit() {
  }

  /**
   * 電話番号の確認モーダル表示
   */
  showMfaTelephoneModalPage1(phoneNumber: string): Observable<boolean> {
    this.phoneNumber = phoneNumber;
    this.bottonDisabled = false;
    this.page1 = '';
    this.page2 = 'none';
    this.mfaTelephoneModal.show();
    return this.observable;
  }

  /**
   * smart-in電話番号案内モーダル表示
   */
  showMfaTelephoneModalPage2(): Observable<boolean> {
    this.page1 = 'none';
    this.page2 = '';
    return this.observable;
  }

  /**
   * 「はい」「いいえ」ボタン押下時
   * はい：confirmFlg true
   * いいえ：confirmFlg false
   */
  execMfaPhone(confirmFlg: boolean): void {
    if (confirmFlg) {
      this.bottonDisabled = true;
    }
    this.observer.next(confirmFlg);
  }

  /**
   * 「キャンセル」ボタン押下時
   */
  cancel(): void {
    this.mfaTelephoneModal.hide();
    this.observer.next(false);
  }

  /**
   * モーダルを閉じる
   */
  hideMfaTelephoneModal(): void {
    this.mfaTelephoneModal.hide();
  }
}
